import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ErrorDialogConfig } from './error-dialog.types';

@Component({
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .error-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class ErrorDialogComponent {
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogConfig,
        public matDialogRef: MatDialogRef<ErrorDialogComponent>
    ) { }

}
